module.exports = __webpack_public_path__ + "img/license.f481c5e9.png";